import React from "react";
import { ReactComponent } from "./arrow-bottom.svg";

export const ArrowBottom = React.forwardRef(
  (props: React.ComponentPropsWithRef<"svg">, ref: React.Ref<SVGSVGElement>) => {
    return <ReactComponent ref={ref} {...props} />;
  }
);
